import { MOBILE } from '../../assets/scripts/constants';
import Popups from '../../components/popups/popups';

class PopupLoyalty {
	constructor() {
		this.container = document.querySelector('[data-popup-loyalty]');
		this.mm = window.matchMedia(MOBILE);

		if (!this.container) return;

		this.init();
	}

	init() {
		const container = this.container;
		const nextStepBtn = this.container.querySelector('[data-loyalty-next-step-btn]');

		nextStepBtn.addEventListener('click', () => {
			this.showNextStep();
		});

		document.querySelector('[data-loyalty-popup-step="2"]')?.addEventListener('click', () => {
			this.showNextStep();
		});

		window.addEventListener('load', () => {
			window.addEventListener('resize', () => {
				if (window.matchMedia(MOBILE).matches && container.dataset.popupLoyalty == 2) {
					container.parentElement.style.transform = 'translateY(-3.5rem)';
				} else {
					container.parentElement.style.transform = 'translateY(0rem)';
				}
			});

			Popups.onCloseStart.add((name) => {
				if (name === 'popup-loyalty') {
					setTimeout(() => {
						container.dataset.popupLoyalty = 1;
						document.documentElement.classList.remove('_show-popup-socials');
					}, 600);
				}
			});

			Popups.onOpen.add((name) => {
				if (name === 'popup-loyalty') {
					container.dataset.popupLoyalty = 1;
					document.documentElement.classList.remove('_show-popup-socials');
				}
			});
		});
	}

	showNextStep() {
		this.container.dataset.popupLoyalty = 2;
		document.documentElement.classList.add('_show-popup-socials');

		if (this.mm.matches) {
			this.container.parentElement.style.transform = 'translateY(-3.5rem)';
		}
	}
}

export default new PopupLoyalty();
